'use client';

import { InputHTMLAttributes, forwardRef } from 'react';
import styles from './Checkbox.module.css';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    ({ label, className = '', ...props }, ref) => {
        return (
            <label className={`${styles.label} ${className}`}>
                <input
                    type="checkbox"
                    className={styles.input}
                    ref={ref}
                    {...props}
                />
                <span className={styles.box}>
                    <span className={styles.checkmark}>✓</span>
                </span>
                {label && <span>{label}</span>}
            </label>
        );
    }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
